import { Outlet } from 'react-router-dom';

export default function FormPanelLayout() {
    return (
        <div className='w-screen h-screen lg:px-0 bg-cover bg-center bg-bg-login'>
            <Outlet />
        </div>
    );
}
